import { FC } from 'react'
import { Row, Col, Text, Breadcrumb } from '@/client/components'
import * as S from './styles'
import { FeaturedProps } from '../types'

export const Featured: FC<FeaturedProps> = ({ breadcrumb, title, subtitle, description }) => (
  <S.Featured>
    <Row>
      <Col>
        <Breadcrumb pages={breadcrumb} />
      </Col>
    </Row>
    <Row>
      <Col>
        <S.Featured>
          <Text as='h2' color='primary' family='heading'>
            {subtitle}
          </Text>
          <Text as='h1' size='xxlg' family='heading' weight='bold' margin='0 0 2.5rem' itemProp='name'>
            {title}
          </Text>

          <Text color='weak'>{description}</Text>
        </S.Featured>
      </Col>
    </Row>
  </S.Featured>
)
